module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vurin19-675def36d7f063ba8bdccb4176fc7b44.jpg";